import { render, staticRenderFns } from "./comparing_score.vue?vue&type=template&id=328c8fb0&scoped=true&"
import script from "./comparing_score.vue?vue&type=script&lang=js&"
export * from "./comparing_score.vue?vue&type=script&lang=js&"
import style0 from "./comparing_score.vue?vue&type=style&index=0&id=328c8fb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328c8fb0",
  null
  
)

export default component.exports